export default __webpack_public_path__ + "static/media/c8.951b1a0a.png";